module.exports = __webpack_public_path__ + "img/gleichstreckenlast.45a0717d.png";